module.exports = __webpack_public_path__ + "static/ss.6bd30ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/sotonite/ss.png
// module id = 286
// module chunks = 140298147566112 277036769636407